import * as actionTypes from './actionTypes';

export const setLeagueModalState=(state)=>{
   return {
      type:actionTypes.SET_LEAGUE_MODAL_STATE,
      payload:state
   }
}